import React from 'react';
import { Component } from '@poa/core';
import { getProfileIcon } from '../../icons/profile';


class AccountGallary extends React.Component {
    store; // injected by Poa

    render() {
        const { originalModel } = this.store.accounts;

        return (
            <div className='general_info__content'>
                {
                    originalModel !== null ?
                        <div className="account-gallary-row">
                            {
                                originalModel.account.dreammarriage.photos.map((photo, idx) => (
                                    <img className="gallary-item" src={photo} alt={idx} />
                                ))
                            }
                            
                        </div>
                        :
                        <div className='main-row'>
                            <div className='no-profile-found-text'>
                                {getProfileIcon('noUser')}
                                Профиль не найден
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default Component({ namespaces: ['account-gallary'] })(AccountGallary);